import { Helpers } from '../../helpers';
import { IState } from '../../interfaces/istate';
import { Asset } from '../asset';
import { County } from '../county';
import { Well } from '../well';

export class StateBase {
  StateId: string;
  Description: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Assets_State?: Array<Asset> | null;
  Counties_State?: Array<County> | null;
  Wells_State?: Array<Well> | null;

  constructor(item?: IState) {
    if (item) {

      this.StateId = item.StateId;
      this.Description = item.Description;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Assets_State = Helpers.createClassArray(Asset, item.Assets_State);
      this.Counties_State = Helpers.createClassArray(County, item.Counties_State);
      this.Wells_State = Helpers.createClassArray(Well, item.Wells_State);
    }
  }
}